import { radialPadLayout } from './radialControlPad.constants.ts';
import type { RadialRingConfig, RadialSectorItem } from './radialControlPad.types.ts';

export const buildDualRingLayout = (
  innerSectors: RadialSectorItem[],
  outerSectors?: RadialSectorItem[]
): { innerRing: RadialRingConfig; outerRing?: RadialRingConfig } => ({
  innerRing: {
    sectors: innerSectors,
    outerRadius: radialPadLayout.ring.innerOuterRadius,
    innerRadius: radialPadLayout.ring.innerHoleRadius,
    iconSize: radialPadLayout.icon.innerSize,
  },
  outerRing: outerSectors
    ? {
        sectors: outerSectors,
        outerRadius: radialPadLayout.ring.outerOuterRadius,
        innerRadius: radialPadLayout.ring.innerOuterRadius + radialPadLayout.ring.gap,
        iconSize: radialPadLayout.icon.outerSize,
      }
    : undefined,
});
